import {
  ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output,
  ViewEncapsulation
} from '@angular/core';
import { TherapiesActionCreatorService } from '../../services/therapies-action-creator.service';
import { Idrug } from '../../interfaces/drug.interface';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'gen-drug-list',
  templateUrl: './drug-list.component.html',
  styleUrls: ['./drug-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class DrugListComponent implements OnInit {
  @Input() drugObjects: any;
  @Input() type: string;
  @Input() caseStatus: boolean;
  @Output() onDrugListChanged: EventEmitter<any> = new EventEmitter<any>();
  public selectable: boolean;
  public selectedDrugs: any = Observable.from([]);
  private destroyer$: Subject<any> = new Subject<any>();

  constructor(private therapiesAC: TherapiesActionCreatorService) {
    this.selectedDrugs = this.therapiesAC.getState('userReview')
      .filter(value => !!value)
      .pluck('therapiesIndex')
      .map((value: any) => value.toArray());
    this.selectedDrugs
      .takeUntil(this.destroyer$.asObservable())
      .subscribe(selectedDrugsList => this.onDrugListChanged.emit(selectedDrugsList));
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.destroyer$.next();
    this.destroyer$.complete();
  }

  onChange(drugObject: Idrug, event: Event) {
    drugObject['source'] = this.type;
    this.therapiesAC.setTherapyInPriority(drugObject);
  }
  getIdentifier(drugObject: Idrug) {
    drugObject['source'] = this.type;
    return TherapiesActionCreatorService.getTherapyIdentifier(drugObject);
  }



}
